import React from 'react';

const CallUs = data => (
    <div>
        <p>Call or Email Direct Hedge:</p>
        <p>
            Phone (USA): <a href="tel:+1 918-640-4644">+1 813 448 7575</a><br/>
            Phone (Spain): <a href="tel:+34 952 378 852">+34 952 378 852</a><br/>
            Phone (Denmark): <a href="tel:+1 918-640-4644">+45 70201297</a>
        </p>
        <p>
          Send email to <a href={'mailto:info@directhedge.com?subject='+encodeURIComponent(data.subject)+'&body='+encodeURIComponent(data.body)}>
            info@directhedge.com</a>
        </p>
    </div>
);

export default CallUs;



// WEBPACK FOOTER //
// ./source/screens/static/CallUs.js